export default __webpack_public_path__ + "static/media/enghien29.b2cf4915.jpg";